/**
 * ══════════════════════════════════════════════════════════════════════════
 * BİLİNMEYEN HATA NESNESİNDEN ALAN OKUMA (strict cırcırı — EMİR #108)
 *
 * ── NEDEN VAR ────────────────────────────────────────────────────────────
 * `strict` altında `catch (e)` değişkeni `unknown` olur, dolayısıyla
 * `e?.message` derlenmez (`TS2339: Property 'message' does not exist on
 * type '{}'`). Kod tabanında bu desen **110 yerde** kullanılıyor — yani
 * tek tek uydurma daraltmalar yazmak 110 ayrı sözleşme demek olurdu.
 *
 * ── NEDEN `instanceof Error` DEĞİL ───────────────────────────────────────
 * ⚠️ ÖLÇÜLDÜ: mevcut `mapError` gövdeleri `e?.message || e?.code` okuyor.
 * `code` alanı `Error` üzerinde YOKTUR — Firebase'in `FirebaseError`'ında
 * vardır. `e instanceof Error ? e.message : undefined` biçiminde bir
 * daraltma derlenirdi, testler de geçerdi, ama **`.code` okumasını sessizce
 * bozardı** ve hata eşlemesi ("İzin reddedildi." vb.) çalışmaz hâle gelirdi.
 * 🧭 Bir tipi daraltırken sorulacak soru "derleniyor mu" değil,
 *    **"kodun bugün okuduğu şeyi hâlâ okuyabiliyor mu"**dur.
 *
 * Bu yüzden okuma **duck-typed** kalır: nesne mi, alan var mı, varsa metne
 * çevir. Davranış `e?.alan` ile birebir aynı; değişen tek şey, derleyicinin
 * artık bunun güvenli olduğunu görmesi.
 * ══════════════════════════════════════════════════════════════════════════
 */

/**
 * `e` bir nesneyse `alan`ını metin olarak döndürür; yoksa `undefined`.
 *
 * `e?.alan` ile aynı sonucu verir:
 *  · `e` null/undefined/ilkel  → `undefined` (ilkelde alan zaten yok)
 *  · alan yok veya null        → `undefined` (böylece `|| yedek` çalışır)
 */
export function hataAlani(e: unknown, alan: string): string | undefined {
  if (typeof e !== "object" || e === null) return undefined;
  const deger = (e as Record<string, unknown>)[alan];
  return deger == null ? undefined : String(deger);
}

/** Sık kullanılan kısayol: hata mesajı. */
export function hataMesaji(e: unknown): string | undefined {
  return hataAlani(e, "message");
}
